import React from 'react';
import { Shield, Users, CheckCircle, Award } from 'lucide-react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <CheckCircle size={48} />,
      title: "No Third Party Mess",
      description: "100 percent in-house operations for all trips! No third parties involved, hence no fishy claims!",
      color: "#00BCD4"
    },
    {
      icon: <Shield size={48} />,
      title: "Transparency & Security",
      description: "Real time monitoring of all trips by ground team! All routes and weather conditions are accurately updated!",
      color: "#14B8A6"
    },
    {
      icon: <Users size={48} />,
      title: "Family-First Filtering",
      description: "Multi-step filtering to bring only like-minded families together! That's our key to have fuss-free trips!",
      color: "#0D9488"
    },
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="why-choose-header">
          <p className="why-choose-subtitle">Why Elite Experiences?</p>
          <h2 className="why-choose-title">Elite Experiences' Secret Sauce</h2>
          <div className="title-underline"></div>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
              <div className="feature-icon" style={{ color: feature.color }}>
                {feature.icon}
              </div>
              <div className="feature-decorations">
                <span className="dot dot-1"></span>
                <span className="dot dot-2"></span>
                <span className="line line-1"></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
